import {
  createContext
} from "react";

const ProfileViewContext = createContext();

export default ProfileViewContext;